export default "__VITE_ASSET__CWzfmavv__"